export function getClientsPath() {
  return '/mandanten'
}
